/**
 * @file Configuration overrides for the client.
 */

/** @type {import('@verosource/myhealth-web/src/config/networkConfig').NetworkConfig} */

const backendBaseUrl = "https://sit.myhealth.gnb-doh.vsfcloud.com/myhealth-gateway"

const networkConfig = {
  keycloakExternalIDP: 'simeio-st',
  keycloakBaseUrl: 'https://iam.sit.myhealth.gnb-doh.vsfcloud.com/auth/',
  patientDataUrl: `${backendBaseUrl}/v3/patient/`,
  dependentDataUrl: `${backendBaseUrl}/v3/delegatedAccess/dependents/`,
  patientSummaryUrl: `${backendBaseUrl}/v1/patient-summary/`,
  patientSummaryManifestUrl: `${backendBaseUrl}/v1/patient-summary/manifest/`,
  patientSummaryViewerUrl: 'https://myhealth-ps-viewer.sit.myhealth.gnb-doh.vsfcloud.com/',
  patientSummaryRevokeUrl: `${backendBaseUrl}/v1/patient-summary/manifest/revoke-access`,
  refreshTokenUrl: `${backendBaseUrl}/v3/authentication/refresh/`,
  medicationUrl: `${backendBaseUrl}/v3/medication/`,
  messagingUrl: `${backendBaseUrl}/v1/messaging/`,
  immunizationUrl: `${backendBaseUrl}/v3/immunization/`,
  observationUrl: `${backendBaseUrl}/v3/diagnosticReport/`,
  imagingUrl: `${backendBaseUrl}/v3/diagnosticImagingReport/`,
  diagnosticReportUrl: 'https://sit.myhealth.gnb-doh.vsfcloud.com/myhealth-gateway/v1/diagnosticReport/',
  encounterUrl: `${backendBaseUrl}/v3/encounter/`,
  alertUrl: 'https://sit.myhealth.gnb-doh.vsfcloud.com/myhealth-gateway/v1/alert/',
  redirectUri: 'https://myhealth-web.sit.myhealth.gnb-doh.vsfcloud.com/',
  loginUrl: `${backendBaseUrl}/v1/authentication/login`,
  authorizeUrl: 'https://sit.id.gnb.ca/as/authorization.oauth2',
  clientId: 'MHNBPHRCLIENT',
  loginProviderType: 'myhealth_broker_sit_new',
  salesforcePortal: 'https://myhealth-st.gnb.ca/s/',
};

export default networkConfig;
